/**
 * Ferreti Pin Upsell Carousel Component
 */
if (!customElements.get('ferreti-pin-upsell')) {
  customElements.define('ferreti-pin-upsell', class FerretiPinUpsell extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.slides = Array.from(this.querySelectorAll('[data-pin-slide]'));
      this.prevBtn = this.querySelector('[data-pin-prev]');
      this.nextBtn = this.querySelector('[data-pin-next]');
      this.counter = this.querySelector('[data-pin-counter]');
      this.addBtns = this.querySelectorAll('[data-pin-add]');
      this.autoplay = this.dataset.autoplay === 'true';

      if (!this.slides.length) return;

      this.initNavigation();
      this.initQuickAdd();
      this.updateUI();

      if (this.autoplay && this.slides.length > 1) {
        this.startAutoplay();
      }
    }

    initNavigation() {
      if (this.slides.length <= 1) {
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        if (this.counter) this.counter.style.display = 'none';
        return;
      }

      this.prevBtn?.addEventListener('click', () => {
        this.pauseAutoplay();
        this.goTo(this.currentIndex - 1);
      });

      this.nextBtn?.addEventListener('click', () => {
        this.pauseAutoplay();
        this.goTo(this.currentIndex + 1);
      });
    }

    goTo(index) {
      const total = this.slides.length;
      this.currentIndex = (index + total) % total;
      this.updateUI();
    }

    updateUI() {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.currentIndex);
      });

      if (this.counter) {
        this.counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      }
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, 4000);

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    initQuickAdd() {
      this.addBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart(btn);
        });
      });
    }

    async addToCart(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.classList.contains('is-loading')) return;

      const spinner = btn.querySelector('.ferreti-pin-upsell__spinner');
      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'true');
      spinner?.classList.remove('hidden');

      try {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        
        let config;
        if (typeof fetchConfig === 'function') {
          config = fetchConfig('javascript');
        } else {
          config = {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
            }
          };
        }

        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Accept'] = 'application/javascript';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (cart && typeof cart.getSectionsToRender === 'function') {
          const sections = cart.getSectionsToRender().map((section) => section.id);
          if (sections.length > 0) {
            formData.append('sections', sections.join(','));
            formData.append('sections_url', window.location.pathname);
          }
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(btn);
          }
        }

        config.body = formData;

        const cartAddUrl = (window.routes && window.routes.cart_add_url) 
          || (typeof routes !== 'undefined' && routes.cart_add_url) 
          || '/cart/add';

        const response = await fetch(cartAddUrl, config);
        const data = await response.json();

        if (data.status && (data.status >= 400 || data.status === 'error')) {
          throw new Error(data.description || data.message || 'No se pudo agregar el pin');
        }

        // Publish event for Dawn PubSub
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ferreti-pin-upsell',
            productVariantId: variantId,
            cartData: data
          });
        }

        // Render contents in cart drawer
        if (cart) {
          if (typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else if (typeof cart.open === 'function') {
            cart.open();
          }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (err) {
        console.error('Ferreti Pin Upsell Error:', err);
        // Fallback: direct simple add if standard sections fetch had issues
        try {
          const fallbackRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          if (fallbackRes.ok) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              window.location.reload();
            }
          }
        } catch (fallbackErr) {
          console.error('Fallback Add failed:', fallbackErr);
        }
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
        spinner?.classList.add('hidden');
      }
    }
  });
}
